import React from 'react'
import Team from './Team'
import Stats from './stats'


import GdTeam from './Gdnew';
import ContentTeam from './Contentnew';
import Newteam from './Newteam';
import PRNewteam from './Newpr';

export default function About() {
    return(
        <div>
            
            <Stats />
            <Team />
            <Newteam/>
            <PRNewteam/>
            <GdTeam />
            <ContentTeam />


        </div>
    )
}